import React,{useState} from "react";
import api from "../../api/api";

import {
Row,
Col,
Card,
Typography,
Form,
Input,
Select,
Button,
Avatar,
Upload
} from "antd";

import {
UserAddOutlined,
UploadOutlined,
EyeOutlined,
EyeInvisibleOutlined,
UserOutlined
} from "@ant-design/icons";

import defaultAvatar from "./studentava.jpg";
import CartoonAlertPopup from "./CartoonAlertPopup";
import "./AddStudentsStaff.css";


const {Title}=Typography;
const {Option}=Select;


const AddStudentsStaff=()=>{

const [form]=Form.useForm();

const [imagePreview,setImagePreview]=useState(null);
const [imageFile,setImageFile]=useState(null);
const [loading,setLoading]=useState(false);

const [popup,setPopup]=useState({
show:false,
type:"",
message:""
});


const handleImageChange=(info)=>{

const file=info.file;

if(file){
setImageFile(file);
setImagePreview(
URL.createObjectURL(file)
);
}

};


const closePopup=()=>{

setPopup({
show:false,
type:"",
message:""
});

};


const handleSubmit=async(values)=>{

setLoading(true);

setPopup({
show:false,
type:"",
message:""
});


const data=new FormData();


Object.entries({
username:values.username,
email:values.email,
password:values.password,
confirm_password:values.confirm_password,
user_type:values.user_type,
gender:values.gender
}).forEach(([key,value])=>{

data.append(key,value);

});


if(imageFile){

data.append(
"profile_image",
imageFile
);

}


try{

const access=localStorage.getItem("access");


const response=await api.post(
"/register/",
data,
{
headers:{
"Content-Type":"multipart/form-data",
Authorization:access
?
`Bearer ${access}`
:
undefined
}
}
);


setPopup({
show:true,
type:"success",
message:
response.data.message ||
"Account created successfully. The new user can now access the system."
});


form.resetFields();

setImagePreview(null);
setImageFile(null);


}
catch(error){

console.log(
error.response?.data
);


let backendMessage=
"Unable to create account. Please check the information and try again.";


if(error.response?.data){

const errors=error.response.data;

const firstError=
Object.values(errors)[0];


if(Array.isArray(firstError)){

backendMessage=firstError[0];

}
else if(typeof firstError==="string"){

backendMessage=firstError;

}

}


setPopup({
show:true,
type:"error",
message:backendMessage
});


}
finally{

setLoading(false);

}

};


return(

<div className="add-user-wrapper">


{
popup.show &&
<CartoonAlertPopup
type={popup.type}
message={popup.message}
onClose={closePopup}
/>
}



<Form
form={form}
layout="vertical"
onFinish={handleSubmit}
>


<Row gutter={[30,30]}>


<Col xs={24} md={8}>


<Card
className="profile-card"
bordered={false}
>


<Avatar
size={170}
src={
imagePreview ||
defaultAvatar
}
icon={
!imagePreview &&
<UserOutlined/>
}
/>


<Title level={4}>
Profile Photo
</Title>


<Upload
beforeUpload={()=>false}
showUploadList={false}
onChange={handleImageChange}
accept="image/*"
>


<Button
icon={<UploadOutlined/>}
>
Upload Image
</Button>


</Upload>


</Card>


</Col>


<Col xs={24} md={16}>


<Card
className="form-card"
bordered={false}
>


<Row gutter={20}>


<Col xs={24} md={12}>


<Form.Item
label="Username"
name="username"
rules={[
{
required:true,
message:"Username is required"
}
]}
>


<Input
size="large"
placeholder="Enter username"
/>


</Form.Item>


</Col>


<Col xs={24} md={12}>


<Form.Item
label="Email Address"
name="email"
rules={[
{
required:true,
message:"Email is required"
},
{
type:"email",
message:"Enter valid email"
}
]}
>


<Input
size="large"
placeholder="Enter email address"
/>


</Form.Item>


</Col>

<Col xs={24} md={12}>


<Form.Item
label="Password"
name="password"
rules={[
{
required:true,
message:"Password required"
},
{
min:8,
message:"Minimum 8 characters"
}
]}
>


<Input.Password
size="large"
placeholder="Create password"
iconRender={
visible=>
visible
?
<EyeOutlined/>
:
<EyeInvisibleOutlined/>
}
/>


</Form.Item>


</Col>


<Col xs={24} md={12}>


<Form.Item
label="Confirm Password"
name="confirm_password"
dependencies={[
"password"
]}
rules={[
{
required:true,
message:"Confirm password required"
},
({getFieldValue})=>({
validator(_,value){

if(
!value ||
getFieldValue("password")===value
){

return Promise.resolve();

}

return Promise.reject(
new Error("Passwords do not match")
);

}
})
]}
>


<Input.Password
size="large"
placeholder="Confirm password"
iconRender={
visible=>
visible
?
<EyeOutlined/>
:
<EyeInvisibleOutlined/>
}
/>


</Form.Item>


</Col>


<Col xs={24} md={12}>


<Form.Item
label="User Role"
name="user_type"
rules={[
{
required:true,
message:"Please select user role"
}
]}
>


<Select
size="large"
placeholder="Select user role"
>
<Option value="student">
Student
</Option>
<Option value="teacher">
Teacher
</Option>
<Option value="parent">
Parent
</Option>
<Option value="principal">
Principal
</Option>
<Option value="registry">
Registry
</Option>
<Option value="admission officer">
Admission Officer
</Option>
<Option value="vpi">
VPI
</Option>
{/* <Option value="vpa">
VPA
</Option> */}
<Option value="it personel">
IT Personnel
</Option>
</Select>
</Form.Item>
</Col>
<Col xs={24} md={12}>


<Form.Item
label="Gender"
name="gender"
rules={[
{
required:true,
message:"Please select gender"
}
]}
>


<Select
size="large"
placeholder="Select gender"
>


<Option value="Male">
Male
</Option>


<Option value="Female">
Female
</Option>


<Option value="Other">
Other
</Option>


</Select>


</Form.Item>


</Col>


</Row>


<Form.Item>


<Button
htmlType="submit"
type="primary"
block
size="large"
loading={loading}
icon={<UserAddOutlined/>}
className="submit-btn"
>


{
loading
?
"Creating Account..."
:
"Create Account"
}


</Button>


</Form.Item>


</Card>


</Col>


</Row>


</Form>


</div>

);

};


export default AddStudentsStaff;
